import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(function (theme) {
  return {
    root: {
      boxShadow: '0px 1px 6px 0px rgba(0,0,0,0.2)',
      padding: '16px',
      [theme.breakpoints.up('1024')]: {
        padding: '24px'
      }
    }
  };
}, {
  name: 'pds-card'
});